import {z} from 'zod';

export const gwpVariantSchema = z.object({
  id: z.number(),
  name: z.string(),
  price: z.number(),
  featured_image: z
    .object({
      src: z.string(),
    })
    .nullable(),
  options: z.array(z.string()),
  selling_plan_allocations: z.array(z.object({selling_plan_id: z.number()})),
});
export type GwpVariant = z.infer<typeof gwpVariantSchema>;

export const gwpBundleSchema = z.object({
  name: z.string(),
  main_variants: z.array(z.string()).optional(),
  gift_variants: z.array(z.string()).optional(),
  discount_codes: z.array(z.string()).optional(),
  price: z.object({amount: z.string().transform(parseFloat)}).optional(),
});
export type GwpBundle = z.infer<typeof gwpBundleSchema>;
